import { render, staticRenderFns } from "./RecoveryConfirmed.vue?vue&type=template&id=170e1215&scoped=true"
import script from "./RecoveryConfirmed.vue?vue&type=script&lang=js"
export * from "./RecoveryConfirmed.vue?vue&type=script&lang=js"
import style0 from "./RecoveryConfirmed.vue?vue&type=style&index=0&id=170e1215&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170e1215",
  null
  
)

export default component.exports